<section>
  <ume-offering-terms-and-conditions-list [terms]="terms"></ume-offering-terms-and-conditions-list>
</section>
